import React from 'react';
import { Accordion } from '../../../components';
import { formatControlValue } from '../../../helpers/Functions';

import { SnippetConfiguration, SnippetDataDictionary } from '../../../services/dataModels';
import { DataRow } from './DataRow';

interface MatrixSnippetProps {
  path: string;
  configuration: SnippetConfiguration;
  data: SnippetDataDictionary[];
  isRollup: boolean;
}

const MatrixSnippet = ({ path, configuration, data, isRollup }: MatrixSnippetProps) => {
  const getTitleControlType = (rowIndex: number, configuration: SnippetConfiguration) => {
    const { rowTitleKey, columns, matrixCells } = configuration;

    const columnIndex = columns.find((c) => c.name === rowTitleKey)?.id;

    return matrixCells.find((c) => c.rowNumber === rowIndex && c.colNumber === columnIndex)
      ?.controlType;
  };

  return (
    <>
      {data.map((r, i) => (
        <Accordion
          key={i}
          size={configuration.columns.length}
          title={formatControlValue(
            getTitleControlType(i + 1, configuration),
            r[configuration.rowTitleKey] as string,
          )}>
          <DataRow
            path={`${path}.rowData[${i}]`}
            configuration={configuration.matrixCells
              .filter((c) => c.rowNumber === i + 1)
              .sort((a, b) =>
                a.rowNumber === b.rowNumber ? a.colNumber - b.colNumber : a.rowNumber - b.rowNumber,
              )
              .map((v, i) => ({
                ...configuration.columns[v.colNumber - 1],
                id: i + 1,
                controlType: v.controlType,
                controlValues: v.controlValues,
              }))}
            data={r}
            disabled={isRollup ? Object.keys(r) : undefined}
          />
        </Accordion>
      ))}
    </>
  );
};

export default MatrixSnippet;
